import type { Cell } from '../types';

// Yugo detection and processing functions

export const checkForYugos = (board: (Cell | null)[][], row: number, col: number, playerColor: 'white' | 'black') => {
  const directions = [
    [-1, 0],  // up
    [-1, 1],  // up-right diagonal  
    [0, 1],   // right
    [1, 1]    // down-right diagonal
  ];
  
  const yugos = [];
  
  for (const [dr, dc] of directions) {
    const line = [{row, col}];
    
    // Collect in positive direction
    let r = row + dr, c = col + dc;
    while (r >= 0 && r < 8 && c >= 0 && c < 8 && 
           board[r][c] && board[r][c]!.color === playerColor) {
      line.push({row: r, col: c});
      r += dr;
      c += dc;
    }
    
    // Collect in negative direction
    r = row - dr;
    c = col - dc;
    while (r >= 0 && r < 8 && c >= 0 && c < 8 && 
           board[r][c] && board[r][c]!.color === playerColor) {
      line.unshift({row: r, col: c});
      r -= dr;
      c -= dc;
    }
    
    if (line.length === 4) {
      yugos.push(line);
    }
  }
  
  return yugos;
};

export const processYugos = (board: (Cell | null)[][], yugos: any[], row: number, col: number) => {
  if (yugos.length === 0) return { yugoFormed: false, removedCells: [] };
  
  const removedCells: {row: number, col: number}[] = [];
  
  // Remove dots from yugos (except yugos and the new placement)
  yugos.forEach(yugo => {
    yugo.forEach((cell: {row: number, col: number}) => {
      if (!(cell.row === row && cell.col === col) && 
          board[cell.row][cell.col] && 
          !board[cell.row][cell.col]!.isYugo) {
        removedCells.push({row: cell.row, col: cell.col});
        board[cell.row][cell.col] = null;
      }
    });
  });
  
  return { yugoFormed: true, removedCells };
};

